import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

/**
 * Loading indicator for file generation
 * Shows while Word, Excel, CSV, PowerPoint, or PDF files are being created
 */
const FileGenerationIndicator = ({ format = 'file', darkMode = false }) => {
  const formatLabel = format.toUpperCase();
  
  return (
    <div className={`file-generation-skeleton ${darkMode ? 'dark' : ''}`}>
      <div className="file-gen-container p-6 border border-gray-200 dark:border-[#444444] rounded-lg bg-gray-50 dark:bg-[#1a1a1a]">
        <div className="flex items-center gap-4">
          <div className="file-icon-container w-12 h-12 rounded-lg bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center">
            <DocumentTextIcon className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="flex-1">
            <div className="file-gen-header mb-2">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-900 dark:text-white">
                  Generating {formatLabel} file
                </span>
                <div className="loading-dots flex gap-1">
                  <span className="dot animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
                  <span className="dot animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
                  <span className="dot animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
                </div>
              </div>
            </div>
            <div className="file-gen-progress">
              <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-blue-600 dark:bg-blue-500 animate-progress" style={{
                  animation: 'progress 2s ease-in-out infinite'
                }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes progress {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }
        
        .dot {
          display: inline-block;
          color: #60a5fa;
        }
        
        .dark .dot {
          color: #3b82f6;
        }
        
        .animate-progress {
          width: 0%;
        }
      `}</style>
    </div>
  );
};

export default FileGenerationIndicator;
